import { createFileRoute } from '@tanstack/react-router'

import { CustomerPageWrapper } from '@/components/molecules/customer-page-wrapper'
import PageHeader from '@/components/molecules/shared/page-header'
import { AccountingReconciliation } from '@/features/accounting/pages/reconciliation'
import Head from '@/lib/navigation/head'

function ReconciliationRoute() {
  return (
    <>
      <Head>
        <title>Reconciliation | Nonresident Tax</title>
      </Head>
      <CustomerPageWrapper stickyHeader={<PageHeader title="Reconciliation" sticky />}>
        <AccountingReconciliation />
      </CustomerPageWrapper>
    </>
  )
}

export const Route = createFileRoute('/_shell/accounting/reconciliation')({
  component: ReconciliationRoute,
})
